"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdGeneratorAbstract = void 0;
var types_1 = require("../../types");
var AdGeneratorAbstract = (function () {
    function AdGeneratorAbstract() {
    }
    AdGeneratorAbstract.prototype.convertPromoToRotation = function (_a) {
        var mediafileData = _a.mediafileData, insertTime = _a.insertTime, campaignType = _a.campaignType, adcompanyId = _a.adcompanyId, _b = _a.priority, priority = _b === void 0 ? 0 : _b;
        return new types_1.GetRotationResult(insertTime.clone().add(mediafileData.crossfadeDuration, "milliseconds"), {
            mediafile: mediafileData,
            mediafileId: mediafileData.id,
            mediafileType: mediafileData.type,
            adcompanyId: adcompanyId,
            playtime: insertTime.clone(),
            priority: priority,
            endTime: insertTime.clone().add(mediafileData.duration, "milliseconds"),
            campaignType: campaignType,
            promoId: mediafileData.id,
        });
    };
    return AdGeneratorAbstract;
}());
exports.AdGeneratorAbstract = AdGeneratorAbstract;
//# sourceMappingURL=AdGeneratorAbstract.js.map